module.exports = __webpack_public_path__ + "img/lender_signup_hero.c2478928.jpg";